import React from 'react'

import ContactForm from 'components/ContactForm'
import ModalButton from 'components/ModalButton'

const ContactModalButton = ({ renderButton, consultantId }) => (
  <ModalButton
    title="Kontakt"
    small
    renderButton={renderButton}
    renderModal={props => (
      <ContactForm consultantId={consultantId} {...props} />
    )}
  />
)
export default ContactModalButton



// WEBPACK FOOTER //
// ./src/components/ContactModalButton.js